import { createRoot } from 'react-dom/client';
import React, { useState, useEffect } from 'react';
const API = '/wp-json/vendors-search/v1/items';
jQuery(function () {
    const root = createRoot(document.getElementById('software-vendors-search'));
    root.render(React.createElement(VendorSearch, null));
});
function VendorSearch() {
    const [items, setItems] = useState([]);
    const [vendors, setVendors] = useState({});
    const [filters, setFilters] = useState({
        vendor: '',
        instrument: '',
        status: '',
        version: '',
        language: '',
    });
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState();
    useEffect(() => {
        fetch(API, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json; charset=UTF-8'
            }
        })
            .then((results) => {
            results.json()
                .then((json) => {
                setItems(json.items);
                setVendors(json.vendors);
            });
        });
    }, []);
    useEffect(() => {
        const filteredItems = items.filter((item) => {
            for (let field of Object.keys(item)) {
                if (filters[field]) {
                    if (filters[field] !== item[field]) {
                        return false;
                    }
                }
            }
            return true;
        });
        setFilteredItems(filteredItems);
    }, [filters]);
    function filter(e) {
        const field = e.target.name.split('---')[1];
        if (field) {
            let filterCopy = Object.assign({}, filters);
            filterCopy[field] = e.target.value == 'null' ? '' : e.target.value;
            setFilters(filterCopy);
            if (field === 'vendor') {
                setSelectedVendor(vendors[e.target.value]);
            }
        }
    }
    function resetFilters(e) {
        setFilters({
            vendor: '',
            instrument: '',
            status: '',
            version: '',
            language: '',
        });
        setSelectedVendor(undefined);
    }
    return (React.createElement("div", { className: 'wm-softwareVendorsSearch' }, items.length == 0 ?
        React.createElement("div", null,
            React.createElement("img", { src: '/wp-content/plugins/toolset-blocks/embedded/res/img/ajax-loader.svg', alt: 'loader' }))
        :
            React.createElement("div", { className: 'wm-softwareVendorsSearch__main' },
                React.createElement(Filters, { filters: filters, vendors: vendors, onChange: filter, reset: resetFilters }),
                React.createElement(VendorInfo, { vendor: selectedVendor }),
                filteredItems.length > 0 &&
                    React.createElement(React.Fragment, null,
                        React.createElement("h2", { className: "h6" }, "Results:"),
                        React.createElement("ul", { className: 'wm-softwareVendorsSearch__list' },
                            React.createElement("li", { className: 'wm-softwareVendorsSearch__listItem', key: -1 },
                                React.createElement(Labels, null)),
                            filteredItems.map((item, index) => {
                                return (React.createElement("li", { key: index, className: 'wm-softwareVendorsSearch__listItem' },
                                    React.createElement("div", null,
                                        React.createElement("div", null, item.vendor),
                                        React.createElement("div", null, item.instrument),
                                        React.createElement("div", null, item.status),
                                        React.createElement("div", null, item.version),
                                        React.createElement("div", null,
                                            item.language,
                                            " ",
                                            item.languageOther))));
                            }))))));
}
function Filters(props) {
    return (React.createElement("div", { className: 'wm-softwareVendorsSearch__filters' },
        React.createElement(Labels, null),
        React.createElement("div", null,
            React.createElement("div", null,
                React.createElement("select", { name: "vendors-search-filter---vendor", value: props.filters.vendor, onChange: props.onChange },
                    React.createElement("option", { value: "null" }, "- select -"),
                    Object.keys(props.vendors).map((option) => {
                        return (React.createElement("option", { key: option, value: option }, option));
                    }))),
            Object.keys(selectOptions).map((field) => {
                return (React.createElement("div", { key: field },
                    React.createElement("select", { name: `vendors-search-filter---${field}`, value: props.filters[field], onChange: props.onChange },
                        React.createElement("option", { value: "null" }, "- select -"),
                        selectOptions[field].map((option) => {
                            return (React.createElement("option", { key: option, value: option }, option));
                        }))));
            })),
        React.createElement("button", { className: 'wm-softwareVendorsSearch__reset', onClick: props.reset }, "Reset")));
}
function VendorInfo(props) {
    return (React.createElement(React.Fragment, null, props.vendor &&
        React.createElement("div", { className: 'wm-softwareVendorsSearch__vendorInfo' },
            React.createElement("h2", { className: "h6" }, "Contact info"),
            React.createElement("ul", { className: 'wm-softwareVendorsSearch__vendorInfoList' },
                React.createElement("li", null,
                    React.createElement("label", null, "Vendor:"),
                    React.createElement("span", null, props.vendor.name)),
                React.createElement("li", null,
                    React.createElement("label", null, "Website:"),
                    React.createElement("span", null,
                        React.createElement("a", { target: "_blank", "aria-label": "Open Vendor website in a new tab", rel: "nofollow", href: props.vendor.website }, props.vendor.website))),
                React.createElement("li", null,
                    React.createElement("label", null, "Product names:"),
                    React.createElement("span", null, props.vendor.productNames)),
                React.createElement("li", null,
                    React.createElement("label", null, "Contact name:"),
                    React.createElement("span", null, props.vendor.contactName)),
                React.createElement("li", null,
                    React.createElement("label", null, "Contact email:"),
                    React.createElement("span", null,
                        React.createElement("a", { href: `mailto:${props.vendor.contactEmail}` }, props.vendor.contactEmail))),
                React.createElement("li", null,
                    React.createElement("label", null, "Contact phone:"),
                    React.createElement("span", null,
                        React.createElement("a", { href: `tel:${props.vendor.contactPhone}` }, props.vendor.contactPhone)))))));
}
function Labels() {
    return (React.createElement("div", { className: 'wm-softwareVendorsSearch__labels' },
        React.createElement("div", null, "Vendor"),
        React.createElement("div", null, "Instrument"),
        React.createElement("div", null, "Status"),
        React.createElement("div", null, "Version"),
        React.createElement("div", null, "Language")));
}
